/** Metadados para formulários e gráficos (admin). */

/** Perfil (natural) + adaptado por dimensão DISC. */
export const DISC_SERIES = [
  {
    key: 'discD' as const,
    adaptedKey: 'discDAdapted' as const,
    short: 'D',
    label: 'Dominância',
    fill: '#ef4444',
  },
  {
    key: 'discI' as const,
    adaptedKey: 'discIAdapted' as const,
    short: 'I',
    label: 'Influência',
    fill: '#eab308',
  },
  {
    key: 'discS' as const,
    adaptedKey: 'discSAdapted' as const,
    short: 'S',
    label: 'Estabilidade',
    fill: '#22c55e',
  },
  {
    key: 'discC' as const,
    adaptedKey: 'discCAdapted' as const,
    short: 'C',
    label: 'Conformidade',
    fill: '#3b82f6',
  },
] as const;

/** Cor das barras DISC adaptado no gráfico. */
export const DISC_ADAPTED_BAR_FILL = '#64748b';

export const VALORES_COMPORTAMENTAIS = [
  { key: 'valEconomico' as const, label: 'Econômico', fill: '#22c55e' },
  { key: 'valEstetico' as const, label: 'Estético', fill: '#a855f7' },
  { key: 'valTeorico' as const, label: 'Teórico', fill: '#3b82f6' },
  { key: 'valPolitico' as const, label: 'Político', fill: '#f97316' },
  { key: 'valSocial' as const, label: 'Social', fill: '#14b8a6' },
  { key: 'valReligioso' as const, label: 'Religioso', fill: '#eab308' },
] as const;

export const TRAIT_ROWS = [
  {
    natural: 'ousadiaNatural' as const,
    adapted: 'ousadiaAdapted' as const,
    label: 'OUSADIA',
  },
  {
    natural: 'comandoNatural' as const,
    adapted: 'comandoAdapted' as const,
    label: 'COMANDO',
  },
  {
    natural: 'objetividadeNatural' as const,
    adapted: 'objetividadeAdapted' as const,
    label: 'OBJETIVIDADE',
  },
  {
    natural: 'assertividadeNatural' as const,
    adapted: 'assertividadeAdapted' as const,
    label: 'ASSERTIVIDADE',
  },
  {
    natural: 'persuasaoNatural' as const,
    adapted: 'persuasaoAdapted' as const,
    label: 'PERSUASÃO',
  },
  {
    natural: 'extroversaoNatural' as const,
    adapted: 'extroversaoAdapted' as const,
    label: 'EXTROVERSÃO',
  },
  {
    natural: 'entusiasmoNatural' as const,
    adapted: 'entusiasmoAdapted' as const,
    label: 'ENTUSIASMO',
  },
  {
    natural: 'sociabilidadeNatural' as const,
    adapted: 'sociabilidadeAdapted' as const,
    label: 'SOCIABILIDADE',
  },
  {
    natural: 'empatiaNatural' as const,
    adapted: 'empatiaAdapted' as const,
    label: 'EMPATIA',
  },
  {
    natural: 'pacienciaNatural' as const,
    adapted: 'pacienciaAdapted' as const,
    label: 'PACIÊNCIA',
  },
  {
    natural: 'persistenciaNatural' as const,
    adapted: 'persistenciaAdapted' as const,
    label: 'PERSISTÊNCIA',
  },
  {
    natural: 'planejamentoNatural' as const,
    adapted: 'planejamentoAdapted' as const,
    label: 'PLANEJAMENTO',
  },
  {
    natural: 'organizacaoNatural' as const,
    adapted: 'organizacaoAdapted' as const,
    label: 'ORGANIZAÇÃO',
  },
  {
    natural: 'detalismoNatural' as const,
    adapted: 'detalismoAdapted' as const,
    label: 'DETALHISMO',
  },
  {
    natural: 'prudenciaNatural' as const,
    adapted: 'prudenciaAdapted' as const,
    label: 'PRUDÊNCIA',
  },
  {
    natural: 'concentracaoNatural' as const,
    adapted: 'concentracaoAdapted' as const,
    label: 'CONCENTRAÇÃO',
  },
] as const;

export type BehavioralFormKey =
  | (typeof DISC_SERIES)[number]['key']
  | (typeof DISC_SERIES)[number]['adaptedKey']
  | (typeof VALORES_COMPORTAMENTAIS)[number]['key']
  | (typeof TRAIT_ROWS)[number]['natural']
  | (typeof TRAIT_ROWS)[number]['adapted'];
